var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Stack, Checkbox, IconButton, TextField, DefaultButton } from 'office-ui-fabric-react';
import { actions } from '../actions';
import { connect } from 'react-redux';
var TodoListItem = /** @class */ (function (_super) {
    __extends(TodoListItem, _super);
    function TodoListItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onEdit = function () {
            var _a = _this.props, id = _a.id, todos = _a.todos;
            var label = todos[id].label;
            _this.setState({
                editing: true,
                editLabel: _this.state.editLabel || label
            });
        };
        _this.onDoneEdit = function () {
            _this.props.edit(_this.props.id, _this.state.editLabel);
            _this.setState({
                editing: false,
                editLabel: undefined
            });
        };
        _this.onChange = function (evt, newValue) {
            _this.setState({ editLabel: newValue });
        };
        _this.state = { editing: false, editLabel: undefined };
        return _this;
    }
    TodoListItem.prototype.render = function () {
        var _a = this.props, id = _a.id, todos = _a.todos, complete = _a.complete, remove = _a.remove;
        var item = todos[id];
        return (React.createElement(Stack, { horizontal: true, verticalAlign: "center", horizontalAlign: "space-between" },
            !this.state.editing && (React.createElement(React.Fragment, null,
                React.createElement(Checkbox, { label: item.label, checked: item.completed, onChange: function () { return complete(id); } }),
                React.createElement("div", null,
                    React.createElement(IconButton, { iconProps: { iconName: 'Edit' }, onClick: this.onEdit }),
                    React.createElement(IconButton, { iconProps: { iconName: 'Cancel' }, onClick: function () { return remove(id); } })))),
            this.state.editing && (React.createElement(Stack.Item, { grow: true },
                React.createElement(Stack, { horizontal: true, gap: 10 },
                    React.createElement(Stack.Item, { grow: true },
                        React.createElement(TextField, { value: this.state.editLabel, onChange: this.onChange })),
                    React.createElement(DefaultButton, { onClick: this.onDoneEdit }, "Save"))))));
    };
    return TodoListItem;
}(React.Component));
var ConnectedTodoListItem = connect(function (state) { return ({ todos: state.todos }); }, function (dispatch) { return ({
    complete: function (id) { return dispatch(actions.complete(id)); },
    remove: function (id) { return dispatch(actions.remove(id)); },
    edit: function (id, label) { return dispatch(actions.edit(id, label)); }
}); })(TodoListItem);
export { ConnectedTodoListItem as TodoListItem };
